<div class="ds-flex ds-flex-col ds-relative">
  <message-group alignment="left" class="ds-bg-background-green">
    {{ message.message }}
    <message-timestamp
      *ngIf="message.timestamp"
      [timestamp]="message.timestamp"
      class="ds-text-secondary-green"
    ></message-timestamp>
  </message-group>
  <div class="ds-mb-lg ds-mt-sm">
    <div class="ds-border-b-[1px] ds-border-tertiary-lightergrey ds-relative">
      <div
        class="
          ds-absolute ds-bg-background-white
          -ds-top-[13px]
          ds-right-[calc(50%-14px)] ds-px-2xs
        "
      >
        <span class="ds-icons-link before:!ds-bg-secondary-green"></span>
      </div>
    </div>
  </div>
</div>
